import React from "react";
import MetaData from "../../components/layout/MetaData";

const CAREER_MILESTONES = [
  {
    year: "2013",
    placement: "bottom",
    icon: "/img/founder/career-2013.png",
    description:
      "Yophy Kwok begins with a job as an assistant for engineering project BOM analysis at her skills.",
  },
  {
    year: "2016",
    placement: "top",
    icon: "/img/founder/career-2016.png",
    description:
      "Sold the first batch of orders worth US$ 1.2 million and ship components in one month. Yophy Kwok began her career at the booth that has only 15 square meters in Hua Qiang N., China.",
  },
  {
    year: "2018",
    placement: "bottom",
    icon: "/img/founder/career-2018.png",
    description:
      "Creatyea is registered as business name Creatyea Technology (SZ) Co. Limited and the website get introduced.",
  },
  {
    year: "2025",
    placement: "top",
    icon: "/img/founder/career-2025.png",
    description:
      "Creatyea began with the first ODM engineering order and designed the POS terminal which would’ve been focused in the North America market.",
  },
  {
    year: "2026",
    placement: "bottom",
    icon: "/img/founder/career-2026.png",
    description:
      "Creatyea took on 15 hardware projects, partnering with Hanmawei to complete and mass-produce five projects in 2026.",
  },
];

/**
 * 创始人页面，展示创始人介绍、职业里程碑并适配桌面端与移动端布局。
 * @returns {JSX.Element} 创始人介绍页面
 */
export default function FounderPage() {
  return (
    <>
      <MetaData
        title="Our Founder"
        description="Discover Yophy Kwok's journey from electronics project support to building Creatyea's hardware innovation business."
        canonicalPath="/our_founder"
      />
      <section className="creatyea-padding our-founder-page">
        <div className="our-founder-hero">
          <div className="our-founder-layout">
            <div className="our-founder-copy">
              <div className="our-founder-tags">
                <span className="our-founder-tag">Career</span>
                <span className="our-founder-tag">
                  One Woman · One Vision · Creatyea
                </span>
              </div>
              <h1 className="our-founder-title">The Journey Behind Creatyea</h1>
              <p className="our-founder-subtitle">
                From Electronics to Hardware Innovation
              </p>
              <p className="our-founder-body">
                Yophy Kwok began her career in 2013 with engineering project
                support and BOM analysis. Starting from a 15-square-meter booth
                in Huaqiangbei, China, she built her business through
                determination, industry expertise, and a vision for better
                hardware solutions.
              </p>
              <p className="our-founder-body">
                Today, Creatyea has evolved from electronic component trading
                to consumer hardware design, ODM engineering, and mass
                production, bringing ideas to life through innovation and
                trusted partnerships.
              </p>
              <div className="our-founder-card">
                <p>
                  From a small beginning to a growing hardware innovation
                  business, Yophy Kwok&apos;s vision continues to shape the
                  future of Creatyea.
                </p>
              </div>
            </div>
            <div className="our-founder-image-col">
              <img
                src="/img/founder/yophy-kwok.png"
                alt="Yophy Kwok"
                className="our-founder-image"
                width="483"
                height="483"
              />
            </div>
          </div>
          <div className="our-founder-corner" aria-hidden="true"></div>
        </div>

        <section className="our-founder-career" aria-labelledby="career-title">
          <h2 id="career-title" className="our-founder-career-title">
            Career
          </h2>
          <ol className="our-founder-timeline">
            {CAREER_MILESTONES.map((milestone) => (
              <li
                key={milestone.year}
                className={`our-founder-milestone our-founder-milestone--${milestone.placement}`}
              >
                <p className="our-founder-milestone-year">{milestone.year}</p>
                <img
                  className="our-founder-milestone-icon"
                  src={milestone.icon}
                  alt=""
                  width="314"
                  height="314"
                  loading="lazy"
                />
                <div className="our-founder-milestone-card">
                  <p>{milestone.description}</p>
                </div>
                <span
                  className="our-founder-milestone-dot"
                  aria-hidden="true"
                ></span>
              </li>
            ))}
          </ol>
        </section>
      </section>
    </>
  );
}
